import api from 'connections/api';
import routes_api from 'connections/routes_api';

// ###### ASSET LOCATIONS
export const createAssetLocation = async (data) => {
  return api.post(routes_api.finance_asset_locations, data);
};
export const updateAssetLocation = async (id, data) => {
  return api.patch(`${routes_api.finance_asset_locations}${id}/`, data);
};
export const deleteAssetLocation = async (id) => {
  return api.delete(`${routes_api.finance_asset_locations}${id}/`);
};

// ###### ASSET CATEGORIES
export const createAssetCategory = async (data) => {
  return api.post(routes_api.finance_asset_categories, data);
};
export const updateAssetCategory = async (id, data) => {
  return api.patch(`${routes_api.finance_asset_categories}${id}/`, data);
};
export const deleteAssetCategory = async (id) => {
  return api.delete(`${routes_api.finance_asset_categories}${id}/`);
};

// ###### ASSETS (ITEMS)
export const createAsset = async (data) => {
  return api.post(routes_api.finance_asset_items, data);
};
export const updateAsset = async (id, data) => {
  return api.patch(`${routes_api.finance_asset_items}${id}/`, data);
};
export const deleteAsset = async (id) => {
  return api.delete(`${routes_api.finance_asset_items}${id}/`);
};

// ###### ASSET OPERATIONS
export const createAssetOperation = async (data) => {
  return api.post(routes_api.finance_asset_operations, data);
};
export const updateAssetOperation = async (id, data) => {
  return api.patch(`${routes_api.finance_asset_operations}${id}/`, data);
};
export const deleteAssetOperation = async (id) => {
  return api.delete(`${routes_api.finance_asset_operations}${id}/`);
};

// ###### ASSET RETURNS
export const createAssetReturn = async (data) => {
  return api.post(routes_api.finance_asset_returns, data);
};
export const updateAssetReturn = async (id, data) => {
  return api.patch(`${routes_api.finance_asset_returns}${id}/`, data);
};
export const deleteAssetReturn = async (id) => {
  return api.delete(`${routes_api.finance_asset_returns}${id}/`);
};

// ###### BALANCE SNAPSHOTS
export const createBalanceSnapshot = async (data) => {
  return api.post(routes_api.finance_asset_snapshots, data);
};
/** Atomic create/update snapshot + replace all items (bulk). */
export const saveBalanceSnapshotWithItems = async (payload) => {
  return api.post(routes_api.finance_asset_snapshots_save_with_items, payload);
};
export const updateBalanceSnapshot = async (id, data) => {
  return api.patch(`${routes_api.finance_asset_snapshots}${id}/`, data);
};
export const deleteBalanceSnapshot = async (id) => {
  return api.delete(`${routes_api.finance_asset_snapshots}${id}/`);
};

// ###### BALANCE SNAPSHOT ITEMS
export const createBalanceSnapshotItem = async (data) => {
  return api.post(routes_api.finance_asset_snapshot_items, data);
};
export const createBalanceSnapshotItemsBatch = async (data) => {
  return api.post(routes_api.finance_asset_snapshot_items_create_batch, data);
};
export const deleteBalanceSnapshotItemsBySnapshot = async (snapshotId) => {
  return api.delete(routes_api.finance_asset_snapshot_items_delete_by_snapshot, {
    params: { snapshot: snapshotId },
  });
};
export const updateBalanceSnapshotItem = async (id, data) => {
  return api.patch(`${routes_api.finance_asset_snapshot_items}${id}/`, data);
};
export const deleteBalanceSnapshotItem = async (id) => {
  return api.delete(`${routes_api.finance_asset_snapshot_items}${id}/`);
};

/** Full bootstrap: locations, categories, assets, operations, returns, snapshots, snapshot_items (with ids). */
export const getAssetsFull = async () => {
  return api.get(routes_api.finance_asset_full);
};

/** Custom balance update checklist: GET returns JSON array of { id, label, order, checked }. */
export const getConfigCustomUpdateSteps = async () => {
  return api.get(routes_api.finance_asset_config_custom_update);
};

/** Replace checklist on server; body must be a JSON array (same shape as GET). */
export const patchConfigCustomUpdateInstructions = async (instructionsArray) => {
  return api.patch(routes_api.finance_asset_config_custom_update, instructionsArray);
};

/** Embedded Notepad note links for Finance workflow slots. */
export const getFinanceEmbeddedNotepadNotes = async () => {
  return api.get(routes_api.finance_asset_embedded_notepad_notes);
};

export const patchFinanceEmbeddedNotepadNotes = async (payload) => {
  return api.patch(routes_api.finance_asset_embedded_notepad_notes, payload);
};

// ###### BATCH CREATE OPERATIONS
export const createManyAssetLocations = async (data) => {
  return api.post(routes_api.finance_asset_locations_create_many, data);
};

export const createManyAssetCategories = async (data) => {
  return api.post(routes_api.finance_asset_categories_create_many, data);
};

export const createManyAssets = async (data) => {
  return api.post(routes_api.finance_asset_items_create_many, data);
};

export const createManyAssetOperations = async (data) => {
  return api.post(routes_api.finance_asset_operations_create_many, data);
};

export const createManyAssetReturns = async (data) => {
  return api.post(routes_api.finance_asset_returns_create_many, data);
};

export const createBalanceSnapshotsBatch = async (data) => {
  return api.post(routes_api.finance_asset_snapshots_create_batch, data);
};

export const importAssetsExcel = async (data) => {
  return api.post(routes_api.finance_asset_items_import_excel, data);
};

export const exportAssetsExcel = async () => {
  return api.get(routes_api.finance_asset_items_export_excel);
};

export const deleteAllAssetsData = async () => {
  return api.post(routes_api.finance_asset_items_delete_all);
};

export const updateSnapshotPositions = async () => {
  return api.post(routes_api.finance_asset_snapshot_items_update_positions);
};

export const updateSnapshotMarketInfo = async () => {
  return api.post(routes_api.finance_asset_snapshot_items_update_market_info);
};

/** Preview Yahoo market fields for draft snapshot rows (no DB write). */
export const previewSnapshotMarketInfo = async ({ snapshot_date, asset_ids }) => {
  return api.post(routes_api.finance_asset_snapshot_items_preview_market_info, {
    snapshot_date,
    asset_ids,
  });
};

/** Year-over-year asset report from operations (as-of 31/Dec). value_mode: net | total */
export const getAssetsYearReport = async (year1, year2, valueMode = 'net') => {
  return api.get(routes_api.finance_asset_year_report, {
    params: { year1, year2, value_mode: valueMode },
  });
};